import { useNavigate } from "react-router-dom";
import { Sparkles, Droplets, ArrowUpRight } from "lucide-react";
import { ADDON, formatPrice } from "../../data/site";
import { Reveal } from "./Reveal";

export default function AddonCard() {
  const navigate = useNavigate();
  return (
    <Reveal>
      <div
        data-testid="addon-card"
        className="relative max-w-4xl mx-auto rounded-3xl border border-brand-blue/25 bg-white card-soft p-6 sm:p-8 overflow-hidden"
      >
        <div className="pointer-events-none absolute -top-16 -right-16 w-56 h-56 rounded-full bg-brand-blue/10 blur-2xl" />
        <div className="relative flex flex-col sm:flex-row sm:items-center gap-6">
          <div className="grid place-items-center w-16 h-16 rounded-2xl bg-brand-blue/10 text-brand-blue shrink-0">
            <Droplets className="w-8 h-8" />
          </div>
          <div className="flex-1 min-w-0">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-brand-blue/10 text-brand-blue text-[11px] font-bold px-3 py-1 uppercase tracking-wider">
              <Sparkles className="w-3.5 h-3.5" />
              New Add-On Service
            </span>
            <h3 className="mt-3 font-display text-2xl font-extrabold text-brand-ink">{ADDON.title}</h3>
            <p className="mt-1.5 text-sm text-brand-muted">{ADDON.desc}</p>
            <p className="mt-2 text-xs font-semibold text-brand-orange">{ADDON.note}</p>
          </div>
          <div className="sm:text-right shrink-0">
            <div className="font-display font-extrabold text-3xl text-brand-blue leading-none">
              + {formatPrice(ADDON.price)}
            </div>
            <div className="text-xs text-brand-muted mt-1 font-medium">/ month</div>
            <button
              data-testid="addon-book-cta"
              onClick={() => navigate("/book?addon=1")}
              className="mt-4 inline-flex items-center justify-center gap-2 bg-brand-blue text-white text-sm font-semibold px-5 py-2.5 rounded-full hover:scale-[1.03] active:scale-95 transition-transform"
            >
              Add to Your Plan
              <ArrowUpRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </Reveal>
  );
}
